import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {LogadoService} from "../../../providers/logado-service";
import {TAction} from "../../../app/enum";
import {CONFIG} from "../../../app/config";
import {HotspotService} from "../../../providers/hotspot-service";

@Component({
    selector: 'page-repasse-menu',
    templateUrl: 'repasse-menu.html',
    providers: [HotspotService]
})
export class RepasseMenuPage {

    logado: any;
    config: any;

    rootpay: any;
    hotspotID: number;

    constructor(public navCtrl: NavController, public navParams: NavParams, public util: Util,
                public hotspotService: HotspotService,
                public logadoService: LogadoService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.hotspotID = this.util.anyParams(0, this.navParams.get('hotspotID'));

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Repasse', '/repasse-menu');

        this.paymentLoad();

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    paymentLoad() {

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.payment(TAction.acYear)
            .finally(() => loading.dismiss())
            .subscribe(data => this.rootpay = data,
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    getTitle() {

        return 'Gateway';

    }

    dismiss() {

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/repasse-menu/repasse-menu.ts